function Belgium({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_641)">
        <path d="M21.5651 0.995188C19.8318 0.352063 17.9571 0 16 0C14.0428 0 12.1681 0.352063 10.4348 0.995188L9.04346 16L10.4348 31.0048C12.1681 31.648 14.0428 32 16 32C17.9571 32 19.8318 31.648 21.5651 31.0048L22.9565 16L21.5651 0.995188Z" fill="#FFDA44"/>
        <path d="M32 15.9999C32 9.12049 27.658 3.25574 21.5652 0.995117V31.0048C27.658 28.744 32 22.8794 32 15.9999Z" fill="#D80027"/>
        <path d="M0 15.9999C0 22.8794 4.342 28.744 10.4348 31.0047V0.995117C4.342 3.25574 0 9.12049 0 15.9999Z" fill="black"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Belgium;
